import { useSuspenseQuery } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import { isAxiosError } from 'axios';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';

export interface GetCampaignsParams {
  params: { accountId: string };
}

export interface CampaignEntry {
  campaign_id: string;
  campaign_name: string;

  [key: string]: unknown;
}

export const getCampaigns = async (
  { params }: GetCampaignsParams,
  signal?: AbortSignal,
): Promise<CampaignEntry[]> => {
  const res = await apiClient.get<CampaignEntry[]>(
    `${queryKeys.campaigns}/${params.accountId}`,
    { signal },
  );

  if (isAxiosError(res)) {
    const error = new Error('Get Campaigns Failed');
    error.cause = res.response?.data;
    return Promise.reject(error);
  }

  return res.data;
};

export interface UseCampaignsOptions {
  params: { accountId: string };
  config?: QueryConfig<typeof getCampaigns>;
}

export const useCampaigns = ({ params, config }: UseCampaignsOptions) => {
  return useSuspenseQuery({
    staleTime: 0,
    refetchOnMount: true,
    ...config,
    queryFn: ({ signal }) => getCampaigns({ params }, signal),
    queryKey: [queryKeys.campaigns, params.accountId],
  });
};
